import { CustomStyledLabel } from '@cat-ecom/pcc-components';
import { CatHeading } from 'components/blocks-components';
import styles from '../../request-equipment-service.module.scss';
import { useTranslations } from 'next-intl';
import { EMAIL_METHOD } from '../../constant';
import { RequestServiceInfoPropsTypes } from '../../types';

interface RequestServiceContactInfoProps {
  requestServiceInfo: RequestServiceInfoPropsTypes;
}

const RequestServiceContactInfo = ({
  requestServiceInfo
}: Readonly<RequestServiceContactInfoProps>) => {
  const t = useTranslations();
  const { contactName, contactMethod, email, phone, companyName } =
    requestServiceInfo.customer;
  const isContactByEmail = contactMethod === EMAIL_METHOD.name;
  const emailPhoneHeading = isContactByEmail
    ? t('MA_EMAIL')
    : t('CAT_EMAIL_PHONE1');
  const emailPhoneLabel = isContactByEmail ? email : phone;
  const emailPhoneTestId = isContactByEmail
    ? 'emailConfirmation'
    : 'phoneConfirmation';

  const contactInfoContent = (
    contactHeading,
    contactDataInfo,
    contactTestId
  ) => {
    return (
      <div className="row mt-3">
        <div className="col-4 col-md-3 pe-2 pe-md-3 text-break">
          <CatHeading variant="body-sm" isDisabled>
            <CustomStyledLabel
              className={styles['request-service__font-color']}
            >
              {contactHeading}
            </CustomStyledLabel>
          </CatHeading>
        </div>
        <div className="col-8 col-md-9 text-break" data-testid={contactTestId}>
          <CatHeading variant="body-sm">
            <CustomStyledLabel>{contactDataInfo}</CustomStyledLabel>
          </CatHeading>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="mb-n2">
        <CatHeading variant="label">
          <CustomStyledLabel>{t('CONTACT_MAIN')}:</CustomStyledLabel>
        </CatHeading>
      </div>
      {contactInfoContent(t('MA_NAME'), contactName, 'nameConformation')}
      {contactInfoContent(emailPhoneHeading, emailPhoneLabel, emailPhoneTestId)}
      {contactInfoContent(
        t('UR_CAT_COMPANY'),
        companyName,
        'companyConformation'
      )}
    </>
  );
};

export default RequestServiceContactInfo;
